// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"361":"2894f715373e1634","7541":"55dc849b5f3081ea"}[chunkId] + ".css";
};